import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/shop_by_brand';

export default function ShopByBrand() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
